<template>
    <div id="courseware">
        <iframe class="course_frame" :src="frame_root+'/course/list?tbkt_token='+token" frameborder="0"></iframe>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                token:"",
                frame_root:VUE_URL_COURSEWARE
            }
        },
        created() {
            this.token=localStorage.getItem("Tbkt-Token")
        },
        methods: {
            
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .course_frame{
        display: block;
        width: 100%;
        height: calc(100vh - 2.4rem);
    }
</style>